import { Component, Inject } from '@angular/core';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { DatePipe } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { CommonService } from '../../../../../shared/services/common.service';
import { ApiService } from '../../../../../shared/services/api.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { event } from 'jquery';
@Component({
  selector: 'app-update-msme-attendance-audit',
  templateUrl: './update-msme-attendance-audit.component.html',
  styleUrl: './update-msme-attendance-audit.component.css'
})



export class UpdateMsmeAttendanceAuditComponent {


 constructor(private datePipe: DatePipe, public dialog: MatDialog, private apiService: ApiService,
    private router: Router, private toastrService: ToastrService, public commonService: CommonService,@Inject(MAT_DIALOG_DATA) public data: any) {
  console.log('Audit Data:', data.EventId);


  this.eventid = data?.EventId || null;

  console.log('Audit EventId:', this.eventid);
  this.EventId = data?.EventId || null;
  
  }

eventid: any;
EventId: any;
dataSource: any[] = [];
totalRecords: number = 0;

pagination: any = {
  pageNumber: 1,
  pageSize: 10,
  searchTerm: '',
  sortColumn: 'CreatedDate',   // ✅ FIXED
  sortDirection: 'DESC',
  searchCol: ''
};

searchTimeout: any;

ngOnInit() {
  this.loadData();
}


exportToExcel(): void {

  const obj = {
    eventId: this.eventid,  // ✅ pass separately
    pageNumber: this.pagination.pageNumber,
    pageSize: this.pagination.pageSize,
    searchTerm: this.eventid,
    sortColumn: this.pagination.sortColumn,
    sortDirection: this.pagination.sortDirection,
    searchCol: this.pagination.searchCol
  };

  this.apiService
    .getRequest(API_ENDPOINTS.MSSIDC.GETEVENTSATTENDANCE, obj)
    .subscribe({
      next: (res: any) => {

        if (res && (res.status || res.Status)) {

          const fullData = res.data || [];

          const exportData = fullData.map((item: any, index: number) => ({
            'Sr No': index + 1,
            'Event ID': item.EventId,
            'Event Name': item.EventName,
            'Total Enroll MSME': item.TotalCapacity,
            'Old Attendance': item.OldCheckedCount,
            'Revised Attendance': item.NewCheckedCount,
            'Updated Date & Time': this.formatDate(item.CreatedDate),
            'Updated By': item.CreatedByName
          }));

          const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);
          const workbook: XLSX.WorkBook = {
            Sheets: { 'Attendance': worksheet },
            SheetNames: ['Attendance']
          };

          const excelBuffer: any = XLSX.write(workbook, {
            bookType: 'xlsx',
            type: 'array'
          });

          this.saveAsExcelFile(excelBuffer, 'Event_Attendance');

        } else {
          console.error('No data found');
        }
      },
      error: (err) => {
        console.error(err);
      }
    });
}
formatDate(date: any): string {
  const d = new Date(date);
  return d.toLocaleString('en-GB'); // dd/mm/yyyy HH:mm
}
saveAsExcelFile(buffer: any, fileName: string): void {
  const data: Blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
  });

  FileSaver.saveAs(data, fileName + '_' + new Date().getTime() + '.xlsx');
}
loadData() {
  const obj = {
    eventId: this.eventid,  // ✅ pass separately
    pageNumber: this.pagination.pageNumber,
    pageSize: this.pagination.pageSize,
    searchTerm: this.eventid,
    sortColumn: this.pagination.sortColumn,
    sortDirection: this.pagination.sortDirection,
    searchCol: this.pagination.searchCol
  };

  this.apiService
    .getRequest(API_ENDPOINTS.MSSIDC.GETEVENTSATTENDANCE, obj)
    .subscribe({
      next: (res: any) => {

        if (res && (res.status || res.Status)) {

          this.dataSource = res.data || [];



          this.totalRecords = res.totalRecords || 0;

          console.log('Bind Data:', this.dataSource);

        } else {
          this.dataSource = [];
          this.totalRecords = 0;
        }

      },
      error: (err) => {
        console.error(err);
        this.dataSource = [];
        this.totalRecords = 0;
      }
    });
}

// 📄 Pagination
onPageChange(event: any) {
  this.pagination.pageNumber = event.pageIndex + 1;
  this.pagination.pageSize = event.pageSize;
  this.loadData();
}

// 🔽 Sorting
sort(column: string) {
  if (this.pagination.sortColumn === column) {
    this.pagination.sortDirection =
      this.pagination.sortDirection === 'ASC' ? 'DESC' : 'ASC';
  } else {
    this.pagination.sortColumn = column;
    this.pagination.sortDirection = 'ASC';
  }

  this.pagination.pageNumber = 1;
  this.loadData();
}

// 🔍 Search (Debounce)
onSearchChange(value: string) {
  clearTimeout(this.searchTimeout);

  this.searchTimeout = setTimeout(() => {
    this.pagination.searchTerm = value;
    this.pagination.pageNumber = 1;
    this.loadData();
  }, 500);
}

onchangeDate() {


  this.router.navigate(['/Msme-Attendance']);


}




msmeList: any[] = [];

pageNumber = 1;
pageSize = 10;
totalRecordsmsme = 0;
searchTermMSME = '';

transactionId: any;
type: string = '';



onSearch() {
  this.pageNumber = 1;
  this.loadData();
}

onPageChangemsme(event: any) {
  this.pageNumber = event.pageIndex + 1;
  this.pageSize = event.pageSize;
  this.loadData();
}

openMsmePopup(item: any, type: string) {

  const obj = {
    transactionId: item.TransactionId,
    type: type,
    pageNumber: 1,
    pageSize: 10,
    searchTerm: '',
    sortColumn: 'CreatedDate',
    sortDirection: 'DESC'
  };

  this.apiService
    .getRequest(API_ENDPOINTS.MSSIDC.getmsmelistforattendance, obj)
    .subscribe({
      next: (res: any) => {

        if (res && (res.status || res.Status)) {

          this.msmeList = res.data || [];
          this.totalRecordsmsme = res.totalRecords || 0;

          console.log('Bind Data:', this.msmeList);

          // ❌ REMOVE THIS
          // const firstModalEl = document.getElementById('attendanceModal');
          // if (firstModalEl) {
          //   const firstModal =
          //     (window as any).bootstrap.Modal.getInstance(firstModalEl);
          //   if (firstModal) {
          //     firstModal.hide();
          //   }
          // }

          // ✅ OPEN SECOND MODAL
          const secondModalEl = document.getElementById('msmeModal');

          if (secondModalEl) {

            const secondModal = new (window as any).bootstrap.Modal(
              secondModalEl,
              {
                backdrop: false, // important
                keyboard: false
              }
            );

            secondModal.show();
          }

        } else {
          this.msmeList = [];
        }

      },
      error: (err) => {
        console.error(err);
        this.msmeList = [];
      }
    });
}
// 🔄 Reset
resetFilters() {
  this.pagination = {
    pageNumber: 1,
    pageSize: 10,
    searchTerm: '',
    sortColumn: 'CreatedOn',
    sortDirection: 'DESC',
    SearchCol: ''
  };

  this.loadData();
}



  attendanceList: any[] = [];




  addAttendance(item: any) {
  if (item.notAttendedCount > 0) {
    item.notAttendedCount--;
    item.attendedCount++;
  }
}

removeAttendance(item: any) {
  if (item.attendedCount > 0) {
    item.attendedCount--;
    item.notAttendedCount++;
  }
}
}
